var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBookMedical = function SvgIconBookMedical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.09,
    height: 12.674,
    viewBox: "0 0 11.09 12.674",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book-medical",
    "data-name": "Icon awesome-book-medical",
    d: "M11.09,8.872V.634A.583.583,0,0,0,10.456,0H2.376A2.334,2.334,0,0,0,0,2.376V10.3a2.334,2.334,0,0,0,2.376,2.376h8.08a.625.625,0,0,0,.634-.634v-.4a.685.685,0,0,0-.238-.475,7.006,7.006,0,0,1,0-1.822.479.479,0,0,0,.238-.475ZM3.565,4.159a.2.2,0,0,1,.2-.2H5.149V2.574a.2.2,0,0,1,.2-.2H6.535a.2.2,0,0,1,.2.2V3.961H8.12a.2.2,0,0,1,.2.2V5.347a.2.2,0,0,1-.2.2H6.733V6.931a.2.2,0,0,1-.2.2H5.347a.2.2,0,0,1-.2-.2V5.545H3.763a.2.2,0,0,1-.2-.2ZM9.427,11.09H2.376a.748.748,0,0,1-.792-.792.794.794,0,0,1,.792-.792h7.05Z",
    fill: "#3d3939"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBookMedical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-book-medical.462516d0.svg";
export { ForwardRef as ReactComponent };